export { default as List } from './List';


// WEBPACK FOOTER //
// ./src/templates/index.js